// The site-specific Config module is swapped in at build time based on the
// SITE environment variable — see NormalModuleReplacementPlugin in
// webpack.config-*.js. The static import below is the default (SITE unset)
// and keeps the IDE/type-checker happy; do NOT hand-edit it per site.
import { Config as Selected } from './Config-mpcap';

const Config = Selected;

export { Config }
